import React, { FC, HTMLProps } from "react";
import cx from "classnames";

import styles from "./styles.module.scss";

interface InputProps extends HTMLProps<HTMLInputElement> {
  inputType?: "password" | "text";
}

const Input: FC<InputProps> = ({ inputType, ...props }) => {
  return (
    <input
      type={inputType || "text"}
      className={cx(styles.input, {
        [styles.inputPassword]: inputType === "password",
      })}
      {...props}
    />
  );
};

export default Input;
